import { render, staticRenderFns } from "./ProvinceCityAreaContent.vue?vue&type=template&id=5dc2250b&scoped=true&"
import script from "./ProvinceCityAreaContent.vue?vue&type=script&lang=ts&"
export * from "./ProvinceCityAreaContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2250b",
  null
  
)

export default component.exports